/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-15 14:32:02
 * @LastEditTime: 2025-08-28 15:08:34
 * @LastEditors: sudo_rm_rf
 */
const roles = ref(<string[]>[]);
const permissions = ref(<string[]>[]);
const moduleList = ref(<string[]>[]);
const getInfo = () => {
  return new Promise((resolve, reject) => {
    get('/system/user/getInfo').then((res: any) => {
      // console.log(res);
      if (res.code != 200) return reject(res.msg);
      roles.value = res.data.roles;
      permissions.value = res.data.permissions;
      get('/device/index/notParam')
        .then((res: any) => {
          // console.log(res);
          if (res.code != 200) return reject(res.msg);
          // console.log(JSON.parse(res.data.desktopInfo));
          moduleList.value = JSON.parse(res.data.desktopInfo).elements.map((item: any) => item.component);
        })
        .finally(() => {
          resolve('');
        });
    });
  });
};
export const useUser = defineStore('user', () => {
  const setRoles = (role: string[]) => {
    roles.value = role;
  };

  return {
    roles,
    permissions,
    moduleList,
    getInfo,
    setRoles,
  };
});

export const initGetInfo = () => {
  return new Promise((resolve, reject) => {
    getInfo().then((res: any) => {
      resolve('');
    });
  });
};
